<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>Welcome Back</h1>
      <p>Login to CanvasBloom Platform</p>
    </div>

    @if (errorMessage) {
      <div class="alert-message error-message">
        {{ errorMessage }}
        @if (showResendVerification) {
          <button
            type="button"
            class="resend-link"
            (click)="resendVerificationEmail()"
            [disabled]="resendingVerification"
            >
            {{ resendingVerification ? 'Sending...' : 'Resend Verification Email' }}
          </button>
        }
      </div>
    }

    @if (resendSuccessMessage) {
      <div class="alert-message success-message">
        {{ resendSuccessMessage }}
      </div>
    }

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          placeholder="Enter your email"
          [class.error]="email?.invalid && email?.touched"
          />
        @if (email?.invalid && email?.touched) {
          <div class="error-message">
            @if (email?.errors?.['required']) {
              <span>Email is required</span>
            }
            @if (email?.errors?.['email']) {
              <span>Invalid email format</span>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          placeholder="Enter your password"
          [class.error]="password?.invalid && password?.touched"
          />
        @if (password?.invalid && password?.touched) {
          <div class="error-message">
            @if (password?.errors?.['required']) {
              <span>Password is required</span>
            }
          </div>
        }
        <div class="forgot-password-link">
          <a routerLink="/forgot-password">Forgot Password?</a>
        </div>
      </div>

      <button
        type="submit"
        class="btn-primary"
        [disabled]="loginForm.invalid || loading"
        >
        {{ loading ? 'Logging in...' : 'Login' }}
      </button>

      <div class="divider">
        <span>OR</span>
      </div>

      <div id="googleSignInButton" class="google-button-container"></div>

      <div class="signup-link">
        Don't have an account? <a routerLink="/signup">Sign up</a>
      </div>
    </form>
  </div>
</div>
